import type { CSSProperties } from 'react'
import styles from './PlatformChip.module.scss'

export type Platform = 'youtube' | 'tiktok' | 'instagram'

const LABELS: Record<Platform, string> = { youtube: 'YouTube', tiktok: 'TikTok', instagram: 'Instagram' }

interface PlatformChipProps {
  platform: Platform
  /** Optional size override. Default ``sm`` matches the inline-row use
   * case in tables; ``md`` is for standalone callouts. */
  size?: 'sm' | 'md'
  /** Inline style overrides for one-off positioning needs (margin, etc.). */
  style?: CSSProperties
  className?: string
}

/**
 * Visual badge for a channel's platform. Centralized so the YouTube /
 * TikTok colors stay consistent across the app — every consumer just
 * passes the slug's platform field and the chip handles the rest.
 *
 * Used by SchedulerPage, JobsPage, future analytics surfaces and
 * anywhere a row needs to call out which video service it lives on.
 */
export function PlatformChip({ platform, size = 'sm', style, className }: PlatformChipProps) {
  const label = LABELS[platform]
  const cls = [styles.chip, styles[platform], styles[size], className].filter(Boolean).join(' ')
  return (
    <span className={cls} style={style} aria-label={`Plataforma: ${label}`}>
      {label}
    </span>
  )
}
